// External Dependencies:
import React from 'react'
import ReactDOM from 'react-dom'
import { StripeProvider, Elements } from 'react-stripe-elements'
import keycode from 'keycode'

// Internal Dependencies:
import StripeForm from 'components/Stripe/StripeForm'

class Stripe extends React.Component {
	constructor( props ) {
		super( props )

		this.state = {
			isOpen: true,
			stripe: null,
			amount: false
		}

		this.root = document.getElementById( 'app-stripe' )
		this.el = document.createElement( 'div' )
	}

	static defaultProps = {
		heading: '',
		acceptText: 'Confirm',
		cancelText: 'Cancel',
		accept: false,
		cancel: false
	}

	componentDidMount() {
		this.root.appendChild( this.el )
		document.documentElement.classList.add( 'with-stripe-modal-open' )
		document.addEventListener( 'mousedown', this.handleClickOutside )
		document.addEventListener( 'keydown', this.handleKeyPress )

		if ( window.Stripe ) {
			this.setState({
				stripe: window.Stripe( siteData.stripe_public_key )
			})
		} else {
			document.querySelector( '#stripe-js' ).addEventListener( 'load', () => {
				this.setState({
					stripe: window.Stripe( siteData.stripe_public_key )
				})
			})
		}
	}

	componentWillUnmount() {
		this.root.removeChild( this.el )
		document.documentElement.classList.remove( 'with-stripe-modal-open' )
		document.removeEventListener( 'mousedown', this.handleClickOutside )
		document.removeEventListener( 'keydown', this.handleKeyPress )
	}

	handleClickOutside = ( e ) => {
		if ( this.outside == e.target ) {
			this.handleCancel()
		}
	}

	handleKeyPress = ( e ) => {
		if ( 'esc' == keycode( e ) ) {
			this.handleCancel()
		}
	}

	handleCancel = () => {
		this.setState({
			isOpen: false
		})

		setTimeout( () => {
			this.props.cancel()
		}, 300 )
	}

	handleClose = () => {
		this.handleCancel()
	}

	render() {
		const { amount, recur, children, heading, acceptText, cancelText } = this.props
		const { isOpen, stripe } = this.state
		const className = isOpen ? 'stripe-modal is-open' : 'stripe-modal is-closed'

		const markup = (
			<StripeProvider stripe={ stripe }>
				<div className={ className } ref={ ( e ) => { this.outside = e } } tabIndex="0">
					<Elements>
						<StripeForm
							amount={ amount }
							recur={ recur }
							handleClose={ this.handleClose }
							handleCancel={ this.handleCancel }
							heading={ heading }
							children={ children }
							acceptText={ acceptText }
							cancelText={ cancelText }
						/>
					</Elements>
				</div>
			</StripeProvider>
		)

		return ReactDOM.createPortal(
			markup,
			this.el,
		)
	}
}

export default Stripe



// WEBPACK FOOTER //
// ./components/Stripe/Stripe.jsx